var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "title": !_vm.dataForm.id ? 'New Protocol' : 'Edit Protocol',
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "width": "1100px",
      "top": "1vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('el-form', {
    ref: "dataForm",
    attrs: {
      "model": _vm.dataForm,
      "rules": _vm.dataRule,
      "label-width": "122px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Protocol Type",
      "prop": "type"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "placeholder": "Select type"
    },
    model: {
      value: _vm.dataForm.type,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "type", $$v);
      },
      expression: "dataForm.type"
    }
  }, _vm._l(_vm.protocolTypeList, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "Supplier",
      "prop": "supplierId"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.supplierId,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "supplierId", $$v);
      },
      expression: "dataForm.supplierId"
    }
  }, _vm._l(_vm.supplierList, function (item) {
    return _c('el-option', {
      key: "supplier-".concat(item.id),
      attrs: {
        "label": item.companyName,
        "value": item.id
      }
    });
  }), 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "Content",
      "prop": "content"
    }
  }, [_c('el-editor', {
    attrs: {
      "height": 500,
      "type": "pure"
    },
    model: {
      value: _vm.dataForm.content,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "content", $$v);
      },
      expression: "dataForm.content"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "File",
      "prop": "payNowUen"
    }
  }, [_c('el-file-uploader', {
    model: {
      value: _vm.dataForm.fileUrl,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "fileUrl", $$v);
      },
      expression: "dataForm.fileUrl"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Content(CN)",
      "prop": "contentCn"
    }
  }, [_c('el-editor', {
    attrs: {
      "height": 500,
      "type": "pure"
    },
    model: {
      value: _vm.dataForm.contentCn,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "contentCn", $$v);
      },
      expression: "dataForm.contentCn"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "File(CN)",
      "prop": "payNowUen"
    }
  }, [_c('el-file-uploader', {
    model: {
      value: _vm.dataForm.fileUrlCn,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "fileUrlCn", $$v);
      },
      expression: "dataForm.fileUrlCn"
    }
  })], 1)], 1), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": function click($event) {
        return _vm.dataFormSubmit();
      }
    }
  }, [_vm._v("Submit")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }